import { gql } from '@apollo/client';

export const EDIT_SURROUNDING_INFORMATION_CATEGORY_MUTATION = gql`
  fragment CommonSurroundingInformationCategoryEdit on SurroundingInformationCategory {
    id
    title
    locale
    hidden
    appSortOrder
  }
  mutation EditSurroundingInformationCategory(
    $id: ID!
    $data: editSurroundingInformationCategoryInput!
  ) {
    updateSurroundingInformationCategory(input: { where: { id: $id }, data: $data }) {
      surroundingInformationCategory {
        ...CommonSurroundingInformationCategoryEdit
      }
    }
  }
`;
